import React from 'react';
import { ShareDatasetModal } from './ShareDatasetModal';
import { WorkflowBuilderModal } from '../workflows/WorkflowBuilderModal';
import OutOfCreditsModal from '../settings/credits/OutOfCreditsModal';

export interface DashboardModalsProps {
  tableId: string | undefined;
  tableName: string;
  // Share modal
  showShareModal: boolean;
  onCloseShareModal: () => void;
  // Workflow modal
  showWorkflowModal: boolean;
  onCloseWorkflowModal: () => void;
  // Out of credits modal
  showOutOfCreditsModal: boolean;
  onCloseOutOfCreditsModal: () => void;
}

export const DashboardModals: React.FC<DashboardModalsProps> = ({
  tableId,
  tableName,
  showShareModal,
  onCloseShareModal,
  showWorkflowModal,
  onCloseWorkflowModal,
  showOutOfCreditsModal,
  onCloseOutOfCreditsModal,
}) => {
  return (
    <>
      {/* Share Modal */}
      {tableId && (
        <ShareDatasetModal
          isOpen={showShareModal}
          onClose={onCloseShareModal}
          tableId={tableId}
          tableName={tableName}
        />
      )}

      {/* Workflow Builder Modal */}
      {tableId && (
        <WorkflowBuilderModal
          isOpen={showWorkflowModal}
          onClose={onCloseWorkflowModal}
          datasetId={tableId}
          datasetName={tableName}
        />
      )}

      {/* Out of Credits Modal */}
      <OutOfCreditsModal
        isOpen={showOutOfCreditsModal}
        onClose={onCloseOutOfCreditsModal}
      />
    </>
  );
};
